/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


/** Import Main React Library Object */
import React, {useContext} from "react";

/** Import Theme Context - Information for colors, etc... */
import ApplicationThemeContext from "@Contexts/Theme";

/** Import React Bootstrap Components */
import {Container, Row} from "react-bootstrap";

/** Import React Spinners Components */
import Loader from "react-loader-spinner"; // Loader Animation Component
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"; // Loader Animation CSS Stylesheet


/** @type MainContentLoaderProps - Props List for Main Content Loader Component */
type MainContentLoaderProps = {
    loaderType?: "Audio" | "BallTriangle" | "Bars" | "Circles" | "Grid" | "Hearts" | "Oval" | "Puff" | "Rings" | "TailSpin" | "ThreeDots" | "Watch" | "RevolvingDot" | "Triangle" | "Plane" | "MutatingDots" | "CradleLoader"; // Loader Type
    componentStyles?: object | null; // Loader Overwritten CSS
    loaderColor?: string | null; // Loader Color
    loaderWidth?: number; // Loader Width Size
    loaderHeight?: number; // Loader Height Size
    cssClasses?: string; // Loader CSS Classes
};


/**
 * @visibleName Main Content Loader Component
 *
 * @return JSX.Element
 */
export const MainContentLoaderComponent = ({
    loaderType = "BallTriangle", componentStyles = null, loaderColor = "#FFF",
    loaderWidth = 150, loaderHeight = 150, cssClasses = ""
}: MainContentLoaderProps): JSX.Element => {


    const THEME = useContext(ApplicationThemeContext);


    componentStyles = {display: "flex", padding: 0, ...componentStyles};

    loaderColor = loaderColor || THEME?.secondarySpecialColor || "#FFF";

    cssClasses = (cssClasses ? `${cssClasses} ` : "") + "main-content-loader-component";


    return (
        <Container fluid={true} className={cssClasses} style={componentStyles}>
            <Container className={"main-content-loader-container"}>
                <Row className={"main-content-loader"} style={{height: "100%", alignItems: "center", justifyContent: "center"}}>

                    <Loader
                        type={loaderType}
                        color={loaderColor}
                        height={loaderWidth}
                        width={loaderHeight}
                    />

                </Row>
            </Container>
        </Container>
    );

};


export default MainContentLoaderComponent;
